import { useState, useRef, useEffect } from 'react'
import AddSongDrawer from './AddSongDrawer'

function Setbar({ songs, activeSongIndex, previewLang, hasChanges, onSongClick, onAddSong, onSave }) {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)
  const songRefs = useRef([])

  useEffect(() => {
    if (activeSongIndex !== null && songRefs.current[activeSongIndex]) {
      songRefs.current[activeSongIndex].scrollIntoView?.({ behavior: 'smooth', inline: 'center' })
    }
  }, [activeSongIndex])

  return (
    <div className="setbar">
      <div className="setbar-songs">
        {songs.map((song, index) => (
          <div
            key={index}
            ref={el => songRefs.current[index] = el}
            className={`setbar-song frosted ticks fs-6${activeSongIndex === index ? ' setbar-song--active ticks--active' : activeSongIndex !== null && Math.abs(activeSongIndex - index) === 1 ? ' setbar-song--adjacent' : ''}`}
            onClick={() => onSongClick(index)}
            onMouseEnter={e => e.currentTarget.scrollIntoView?.({ behavior: 'smooth', inline: 'nearest', block: 'nearest' })}
          >
            <span className="fg-l2">
              {previewLang === 'ml' && song.title2 ? song.title2 : song.title}
            </span>
          </div>
        ))}
      </div>
      <div className="setbar-actions">
        <button className="taskbar-action fs-6" onClick={() => setIsDrawerOpen(true)}>+</button>
        {hasChanges && (
          <button className="taskbar-action fs-6" onClick={onSave}>Save</button>
        )}
      </div>
      {isDrawerOpen && (
        <AddSongDrawer
          onAddSong={onAddSong}
          onClose={() => setIsDrawerOpen(false)}
        />
      )}
    </div>
  )
}

export default Setbar
